import { UserMenu, type UserMenuAction } from "@zfp-akademie-a-s/zfp-design";
import { CodeIcon, HelpIcon, HomeIcon, LogoutIcon } from "@zfp-akademie-a-s/zfp-design/icons";
import { JWT_KEY } from "Auth/Models/AuthConstants";
import { DevTools } from "Components/_Shared/DevTools/DevTools";
import { useLogoutZfpSso } from "Infrastructure/ApiZfp/AnalyzerApi";
import { Configuration } from "Infrastructure/Config/config";
import { useUserContext } from "Infrastructure/Context/UserContext";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { AppRouting } from "Infrastructure/Utils/UrlUtils";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

export const AppBarUserMenu = () => {
  const { refetch: fetchLogoutUrl } = useLogoutZfpSso(
    { redirectUrl: `${window.location.protocol}//${window.location.host}` },
    { query: { enabled: false } },
  );
  const { t } = useResource();
  const navigate = useNavigate();
  const { user } = useUserContext();
  const isDevelopment = Configuration.getIsDevelopment();
  const [isDevToolsOpen, setIsDevToolsOpen] = useState(false);

  const handleLogout = async () => {
    try {
      const { data } = await fetchLogoutUrl();
      if (data?.url) {
        window.location.replace(data.url);
      }
    } catch (error) {
      console.error(error);
    } finally {
      localStorage.removeItem(JWT_KEY);
    }
  };

  const actions: UserMenuAction[] = [
    { label: t(Resources.UserMenu.ZfpGroup), icon: <HomeIcon />, href: "https://www.zfpgroup.cz/", target: "_blank" },
    {
      label: t(Resources.ReportIssue.Title),
      icon: <HelpIcon />,
      onClick: () => navigate(AppRouting.FAQ.path()),
    },
    ...(isDevelopment ? [{ label: t(Resources.DevTools.Title), icon: <CodeIcon />, onClick: () => setIsDevToolsOpen(true) }] : []),
    { label: t(Resources.Common.SignOut), icon: <LogoutIcon />, onClick: handleLogout },
  ];

  return (
    <>
      <UserMenu
        user={{
          firstName: user?.firstName,
          lastName: user?.lastName,
          email: user?.email,
          phone: user?.phone,
          photoUrl: user?.profilePictureUrl,
        }}
        buttonLabel={t(Resources.UserMenu.Open)}
        contactLabels={{ phone: t(Resources.Common.Phone), email: t(Resources.Common.Email) }}
        actions={actions}
      />
      {isDevelopment && <DevTools isOpen={isDevToolsOpen} onClose={() => setIsDevToolsOpen(false)} />}
    </>
  );
};
